<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoListar">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoListar">
            <div class="formgroup" *ngIf="permissaoInserir">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <button
                            pButton
                            pRipple
                            routerLink="/apps/consumo/inserir"
                            label="Novo"
                            icon="pi pi-plus"
                            class="p-button-outlined sm:w-9rem"
                        ></button>
                    </div>
                </div>
            </div>
            <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <p-table
                #dt1
                [value]="consumos"
                dataKey="id"
                [rows]="10"
                [rowHover]="true"
                [loading]="loading"
                [paginator]="true"
                [globalFilterFields]="['dataTransacao', 'nomeProfissional', 'valorACobrar']"
                responsiveLayout="stack"
                styleClass=" p-datatable-sm"
            >
                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-column sm:flex-row">
                        <div class="p-fluid sm:mr-2">
                            <label htmlFor="filtroData">Filtrar por Mês/Ano</label>
                            <p-calendar
                                view="month"
                                dateFormat="mm/yy"
                                [showIcon]="true"
                                [readonlyInput]="true"
                                [(ngModel)]="filtroDataRegistro"
                                (ngModelChange)="listarConsumos()"
                            ></p-calendar>
                        </div>
                        <div class="p-fluid mt-2 sm:mt-4">
                            <div class="flex">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input
                                        pInputText
                                        type="text"
                                        #filter
                                        (input)="buscar(dt1, $event)"
                                        placeholder="Buscar"
                                        class="w-full"
                                    />
                                </span>
                                <span class="ml-2">
                                    <button
                                        pButton
                                        class="p-button-outlined"
                                        icon="pi pi-filter-slash"
                                        pTooltip="Limpar Filtros"
                                        (click)="limpar(dt1)"
                                    ></button>
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="dataTransacao">
                            Data Transação
                            <p-sortIcon field="dataTransacao"></p-sortIcon>
                        </th>
                        <th pSortableColumn="nomeProfissional">
                            Nome Profissional
                            <p-sortIcon field="nomeProfissional"></p-sortIcon>
                        </th>
                        <th pSortableColumn="valorACobrar">
                            Valor a Cobrar
                            <p-sortIcon field="valorACobrar"></p-sortIcon>
                        </th>

                        <th style="text-align: center">
                            <div>Ações</div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                    <tr>
                        <td>
                            {{ item.dataTransacao | date: "dd/MM/yyyy" }}
                        </td>
                        <td>
                            {{ item.nomeProfissional }}
                        </td>
                        <td>
                            {{ item.valorACobrar | currency: "BRL" }}
                        </td>

                        <td style="text-align: center">
                            <div>
                                <button
                                    *ngIf="permissaoDetalhar"
                                    pButton
                                    pRipple
                                    pTooltip="Detalhar"
                                    (click)="detalhar(item.id)"
                                    icon="pi pi-eye"
                                    class="p-button-info mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoEditar"
                                    pButton
                                    pRipple
                                    pTooltip="Editar"
                                    (click)="editar(item.id)"
                                    icon="pi pi-pencil"
                                    class="p-button-success mr-2 mb-2"
                                ></button>
                                <button
                                    *ngIf="permissaoExcluir"
                                    pButton
                                    pRipple
                                    pTooltip="Excluir"
                                    icon="pi pi-trash"
                                    (click)="excluir(item.id)"
                                    class="p-button-danger mr-2 mb-2 sm"
                                ></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">Nenhum registro encontrado.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="loadingbody">
                    <tr>
                        <td colspan="7">Carregando contratos. Por favor aguarde.</td>
                    </tr>
                </ng-template>
            </p-table>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
